import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import axios from '@src/service/axios';
import queryString from 'query-string';
import { toast } from 'react-toastify';

// Loader Components
import showLoader from '@components/loader';

export const getDepartment = createAsyncThunk('departmentSlice/getDepartment', async () => {
    try {
        let response = await axios.get('/department', {
            headers: {
                'Content-Type': 'application/json'
            }
        });
        return Promise.resolve(response.data);
    } catch (err) {
        toast.error(err?.response?.data?.message || 'Something went wrong!');
        return Promise.reject(err);
    }
});
export const getDepartmentById = createAsyncThunk('departmentSlice/getDepartmentById', async (data) => {
    try {
        let response = await axios.get(`/department/${data?.id}`, {
            headers: {
                'Content-Type': 'application/json'
            }
        });
        return Promise.resolve(response.data);
    } catch (err) {
        toast.error(err?.response?.data?.message || 'Something went wrong!');
        return Promise.reject(err);
    }
});
export const getDepartmentOption = createAsyncThunk('departmentSlice/getDepartmentOption', async (data) => {
    try {
        showLoader(true);
        const query = queryString.stringify(data);
        let response = await axios.get('/department/options' + `?${query}`, {
            headers: {
                'Content-Type': 'application/json'
            }
        });
        showLoader(false);
        return Promise.resolve(response.data);
    } catch (err) {
        showLoader(false);
        toast.error(err?.response?.data?.message || 'Something went wrong!');
        return Promise.reject(err);
    }
});

export const createDepartment = createAsyncThunk('departmentSlice/createDepartment', async (data, { dispatch }) => {
    try {
        showLoader(true);

        let response = await axios.post('/department', data, {
            headers: {
                'Content-Type': 'application/json'
            }
        });
        toast.success(response?.data?.message || 'Department created successfully.');
        dispatch(getDepartment());
        showLoader(false);
        return Promise.resolve(response.data);
    } catch (err) {
        showLoader(false);
        toast.error(err?.response?.data?.message || 'Something went wrong!');
        return Promise.reject(err);
    }
});

export const updateDepartment = createAsyncThunk('departmentSlice/updateDepartment', async (data, { dispatch }) => {
    try {
        showLoader(true);

        let response = await axios.put('/department/' + data?.id, data?.data, {
            headers: {
                'Content-Type': 'application/json'
            }
        });
        toast.success(response?.data?.message || 'Department updated successfully.');
        dispatch(getDepartment());
        showLoader(false);
        return Promise.resolve(response.data);
    } catch (err) {
        showLoader(false);
        toast.error(err?.response?.data?.message || 'Something went wrong!');
        return Promise.reject(err);
    }
});

export const deleteDepartment = createAsyncThunk('departmentSlice/deleteDepartment', async (deleteId, { dispatch }) => {
    try {
        showLoader(true);

        let response = await axios.delete('/department/' + deleteId, {
            headers: {
                'Content-Type': 'application/json'
            }
        });
        toast.success(response?.data?.message || 'Department deleted successfully');
        dispatch(getDepartment());
        showLoader(false);
        return Promise.resolve(response.data);
    } catch (err) {
        showLoader(false);
        toast.error(err?.response?.data?.message || 'Something went wrong!');
        return Promise.reject(err);
    }
});

export const updateDepartmentStatus = createAsyncThunk('departmentSlice/updateDepartmentStatus', async (id, { dispatch }) => {
    try {
        showLoader(true);

        let response = await axios.put('/department/status/' + id, {
            headers: {
                'Content-Type': 'application/json'
            }
        });
        toast.success(response?.data?.message || 'Status updated successfully.');
        dispatch(getDepartment());
        showLoader(false);
        return Promise.resolve(response.data);
    } catch (err) {
        showLoader(false);
        toast.err(err?.response?.data?.message || 'Something went wrong!');
        return Promise.reject(err);
    }
});

export const departmentSlice = createSlice({
    name: 'departmentSlice',
    initialState: {
        data: [],
        option: []
    },
    reducers: {},
    extraReducers: (builder) => {
        builder.addCase(getDepartment.fulfilled, (state, action) => {
            state.data = action.payload;
            return;
        });
        builder.addCase(getDepartmentOption.fulfilled, (state, action) => {
            state.option = action.payload;
            return;
        });
    }
});

export default departmentSlice.reducer;
